import { useHighDeltaSlippagePercentage } from "#/store/app/portfolio/settings/highDeltaSlippagePercentage";
import { useLowDeltaSlippagePercentage } from "#/store/app/portfolio/settings/lowDeltaSlippagePercentage";
import { useMidDeltaSlippagePercentage } from "#/store/app/portfolio/settings/midDeltaSlippagePercentage";

export interface DeltaSlippage {
  highDeltaSlippageFactor: number;
  midDeltaSlippageFactor: number;
  lowDeltaSlippageFactor: number;
  highDeltaSlippagePercentage: number;
  midDeltaSlippagePercentage: number;
  lowDeltaSlippagePercentage: number;
}

export const useDeltaSlippage = (): DeltaSlippage => {
  const { highDeltaSlippagePercentage, highDeltaSlippageFactor } =
    useHighDeltaSlippagePercentage();
  const { midDeltaSlippagePercentage, midDeltaSlippageFactor } =
    useMidDeltaSlippagePercentage();
  const { lowDeltaSlippagePercentage, lowDeltaSlippageFactor } =
    useLowDeltaSlippagePercentage();
  return {
    highDeltaSlippagePercentage,
    highDeltaSlippageFactor,
    midDeltaSlippagePercentage,
    midDeltaSlippageFactor,
    lowDeltaSlippagePercentage,
    lowDeltaSlippageFactor,
  };
};
